import React from 'react';
import IconType from './iconType';

function VideoIcon({ color = '#757575', width = 14, height = 15, ...rest }: IconType) {
  return (
    <svg {...rest} width={width} height={height} viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.1875 11.875H1.75C1.51794 11.875 1.29538 11.7828 1.13128 11.6187C0.967187 11.4546 0.875 11.2321 0.875 11V4C0.875 3.76794 0.967187 3.54538 1.13128 3.38128C1.29538 3.21719 1.51794 3.125 1.75 3.125H9.1875C9.41956 3.125 9.64212 3.21719 9.80622 3.38128C9.97031 3.54538 10.0625 3.76794 10.0625 4V5.77625L12.4338 4.08312C12.499 4.03663 12.5759 4.00897 12.6558 4.00317C12.7358 3.99736 12.8158 4.01363 12.8871 4.0502C12.9584 4.08676 13.0183 4.14223 13.0603 4.21053C13.1022 4.27883 13.1246 4.35734 13.125 4.4375V10.5625C13.1246 10.6427 13.1022 10.7212 13.0603 10.7895C13.0183 10.8578 12.9584 10.9132 12.8871 10.9498C12.8158 10.9864 12.7358 11.0026 12.6558 10.9968C12.5759 10.991 12.499 10.9634 12.4338 10.9169L10.0625 9.22375V11C10.0625 11.2321 9.97031 11.4546 9.80622 11.6187C9.64212 11.7828 9.41956 11.875 9.1875 11.875Z"
        fill={color}
      />
    </svg>
  );
}

export default VideoIcon;
